import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../../core/services/api.service';
import { NotifyService } from '../../../core/services/notify.service';
import { ActionModalData } from '../../../core/interfaces/action-modal.interface';
import { DocumentCodeEnum } from '../../../core/enums/document.enum';
import { ServiceCodeEnum } from '../../../core/enums/service.enum';

interface ReviewActionPayload {
  event: string;
  comment?: string;
  attachmentId?: string;
}
@Component({
  selector: 'app-action-modal',
  templateUrl: './action-modal.component.html',
  styleUrls: ['./action-modal.component.scss']
})
export class ActionModalComponent implements OnInit {
  reason = '';
  form!: FormGroup;
  isLoading = false;
  DocumentCodeEnum = DocumentCodeEnum;
  ServiceCodeEnum = ServiceCodeEnum;

  constructor(
    public dialogRef: MatDialogRef<ActionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionModalData,
    private fb: FormBuilder,
    private apiService: ApiService,
    private notifyService: NotifyService,
  ) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      reason: [''],
      licensingCommitteeResolution: [null]
    });
  }

  close(val?: any) { this.dialogRef.close(val); }

  confirmReject() {
    if (this.data.handleApi && this.data.applicationId && this.data.event) {
      this.approvalAction(this.form.value.reason);
    } else {
      this.dialogRef.close(this.data.allowComment
        ? { confirmed: true, mode: this.data.mode, comment: this.form.value.reason }
        : { reason: this.form.value.reason });
    }
  }

  sendQuery() {
    if (this.data.handleApi && this.data.applicationId && this.data.event) {
      this.approvalAction(this.form.value.reason);
    } else {
      this.dialogRef.close(this.data.allowComment
        ? { confirmed: true, mode: this.data.mode, comment: this.form.value.reason }
        : { reason: this.form.value.reason });
    }
  }

  confirmInfo() {
    if (this.data.handleApi && this.data.applicationId && this.data.event) {
      this.approvalAction('');
    } else {
      this.dialogRef.close({ confirmed: true, mode: this.data.mode, comment: this.form.value.reason });
    }
  }

  // Centralized API call for approval actions
  private approvalAction(comment: string) {
    if (!this.data.applicationId || !this.data.event) {
      this.notifyService.notifyErrorMessage('Missing application ID or event');
      return;
    }

    if (this.data.service === ServiceCodeEnum.LICENSING && !this.form.value.licensingCommitteeResolution) {
      this.notifyService.notifyErrorMessage('Please upload licensing committee resolution');
      return;
    }

    const formValue = this.form.value;
    this.isLoading = true;
    const payload: ReviewActionPayload = {
      event: this.data.event,
      comment: comment,
      attachmentId: formValue.licensingCommitteeResolution?.attachmentId
    };


    this.apiService.reviewAction(this.data.applicationId, payload.event, payload.comment, payload.attachmentId).subscribe({
      next: () => {
        this.isLoading = false;
        const actionLabel = this.getActionLabel();
        this.notifyService.notifySuccessMessage(`Application ${actionLabel} successfully`);

        // if (this.data.onSuccess) {
        //   this.data.onSuccess();
        // }
        this.dialogRef.close({ success: true, mode: this.data.mode });
      },
      error: (error) => {
        this.isLoading = false;
        const actionLabel = this.getActionLabel();
        this.notifyService.notifyErrorMessage(`Failed to ${actionLabel} application`, error?.error.message);
      }
    });
  }

  confirmDelete() {
    if (this.data.handleApi && this.data.applicationId && this.data.event) {
      this.deleteApplication(this.form.value.reason);
    }
  }

  private deleteApplication(comment: string) {
    this.isLoading = true;
    this.apiService.deleteApplication(this.data.applicationId, comment).subscribe({
      next: () => {
        this.isLoading = false;
        this.notifyService.notifySuccessMessage(`Application deleted successfully`);
        this.dialogRef.close({ success: true, mode: this.data.mode });
      },
      error: (error) => {
        this.isLoading = false;
        this.notifyService.notifyErrorMessage(`Failed to delete application`, error?.error.message);
      }
    });
  }

  private getActionLabel(): string {
    switch (this.data.mode) {
      case 'approve': return 'approved';
      case 'book': return 'booked';
      case 'reject': return 'rejected';
      case 'delete': return 'deleted';
      case 'query': return 'queried';
      default: return this.data.mode;
    }
  }




}
